import { Card, CardContent, CardMedia, Typography, Button, Box, Stack } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { getFileUrl } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { Postcard } from '../types/postcard';

interface GalleryPostcardProps {
  postcard: Postcard;
  viewMode: 'grid' | 'list';
}

const GalleryPostcard = ({ postcard, viewMode }: GalleryPostcardProps) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card 
        sx={{ 
          height: '100%', 
          display: 'flex', 
          flexDirection: viewMode === 'grid' ? 'column' : 'row',
          borderRadius: 2,
          overflow: 'hidden',
          cursor: 'pointer',
          '&:hover': {
            boxShadow: 6,
            transform: 'translateY(-4px)',
            transition: 'all 0.2s ease-in-out',
          },
        }}
        onClick={() => navigate(`/postcards/${postcard.id}`)}
      >
        <CardMedia
          component="img"
          sx={{ 
            height: viewMode === 'grid' ? 200 : '100%',
            width: viewMode === 'grid' ? '100%' : 200,
            objectFit: 'cover',
          }}
          image={getFileUrl(postcard.imageUrl)}
          alt="Postcard"
        />
        <CardContent 
          sx={{ 
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: 3,
          }}
        >
          <Box>
            <Typography gutterBottom variant="h6" component="h2" fontWeight="bold">
              {postcard.template.title}
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/checkout/${postcard.id}`);
              }}
              fullWidth={viewMode === 'grid'}
              size="large"
            >
              Send It
            </Button>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default GalleryPostcard; 